<template>
	<div class="landing-head" :class="`landing-head_align_${logoAlignment}`">
		<inline-svg
			class="landing-head__logo"
			:class="[`landing-head__logo_color_${logoColor}`, `landing-head__logo_${logo}`]"
			:src="logoSrc"
		/>
	</div>
</template>

<script>
import logoInlineToBeColoredSvg from '@/assets/logos/logo-inline-to-be-colored.svg'
import logoMoveInlineToBeColoredSvg from '@/assets/logos/logo-move-inline-to-be-colored.svg'

export default {
	name: 'LandingHead',

	props: {
		logoAlignment: {
			type: String,
			default: 'center',
			validator(v) {
				return ['left', 'center'].includes(v)
			},
		},

		logoColor: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'accent', 'white'].includes(value),
		},

		logo: {
			type: String,
			default: 'simple',
			validator: (value) => ['simple', 'move'].includes(value),
		},
	},

	computed: {
		logoSrc() {
			return this.logo === 'move' ? logoMoveInlineToBeColoredSvg : logoInlineToBeColoredSvg
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-head {
	padding-top: var(--size-18);
	padding-bottom: var(--size-18);

	box-sizing: content-box;
	height: var(--size-28);

	&_align {
		&_left {
			text-align: left;
		}

		&_center {
			text-align: center;
		}
	}

	&__logo {
		width: auto;
		height: 100%;

		// Move-лого по дизайну ниже Simple-лого: фиксированные 16px вместо высоты хедера (28px)
		&_move {
			height: var(--size-16);
		}

		&_color {
			&_primary {
				color: var(--Text-Primary-100);
			}

			&_accent {
				color: var(--Text-Accent);
			}

			&_white {
				color: var(--Fill-White);
			}
		}
	}
}
</style>
